import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const EditApplicationPhaseSkeleton = () => {
  return (
    <Box gap="s24">
      <Box gap="s4">
        <Skeleton height="s16" width="s80" />
        <Skeleton height="s40" width="full" />
      </Box>
      <Box gap="s4">
        <Skeleton height="s16" width="s96" />
        <Skeleton height="s40" width="full" />
      </Box>
    </Box>
  )
}
